import { RouteConfig } from 'vue-router'
import Main from '../Machine/Main.vue'

export const machineRoutes: RouteConfig = {
  path: '/machine',
  name: 'machine',
  component: Main
}
